import axios, { type AxiosInstance } from "axios";
import { File, Paths } from "expo-file-system";
import { API_HOST } from "~/constants/environment";
import type { ApiError } from "~/providers/ApiProvider";

export function createClient(onError?: (error: ApiError) => unknown): AxiosInstance {
    const client = axios.create({ baseURL: API_HOST });

    if (onError) {
        client.interceptors.request.use(null, onError);
        client.interceptors.response.use(null, onError);
    }
    return client;
}

interface IdKeyedRecord {
    id: string;
}

export function mergeQuery<T extends IdKeyedRecord>(record: T): (cache?: T[]) => T[] {
    return (cache?: T[]) => {
        const current = [...(cache ?? [])];
        const idx = current.findIndex((i) => i.id === record.id);

        if (idx >= 0) {
            current[idx] = record;
        } else {
            current.push(record);
        }

        return current;
    };
}

export function removeQuery(id: string): (cache?: IdKeyedRecord[]) => IdKeyedRecord[] {
    return (cache?: IdKeyedRecord[]) => (cache ?? []).filter((item) => item.id !== id);
}

export async function deleteQuery(client: AxiosInstance, url: string, id: string) {
    return await client
        .delete(url)
        .then(() => id)
        .catch((error: ApiError) => {
            if (error.status === 404) {
                return id;
            }

            throw error;
        });
}
export function documentFile(filename: string): File {
    return new File(Paths.document, filename);
}
